/**
 * @since 7.1.0
 */
export interface GetRemindersFromListsOptions {
  /**
   * @since 7.1.0
   */
  listIds: string[];
}
